import { useTranslation } from "react-i18next";
import { STORAGE_KEYS, loadTranslations } from "./useTranslations";

export const useTranslationService = () => {
  const { i18n } = useTranslation();

  const changeLanguage = async (languageCode) => {
    try {
      await loadTranslations(languageCode);
      await i18n.changeLanguage(languageCode);

      localStorage.setItem(STORAGE_KEYS.LANGUAGE, languageCode);
    } catch (error) {
      console.error("Error changing language:", error);
    }
  };

  return {
    language: i18n.language,
    changeLanguage,
  };
};
